import { useEffect, useRef } from "react";
import PageContainer from "@components/layout/PageContainer";
import { useNavigate } from "react-router-dom";
import ModelIndex, { ModelIndexHandle } from "@components/layout/ModelIndex";
import { faCopy, faEdit, faTrash } from "@fortawesome/free-solid-svg-icons";
import { InvoiceTemplateApi, InvoiceTemplateDataType } from "@/api/InvoiceTemplateApi";
import { showAlert } from "@utils/Alert";
import styles from "./style.module.scss";

const InvoiceTemplateIndex = () => {
  const navigate = useNavigate();
  const modelRef = useRef<ModelIndexHandle>(null);

  useEffect(() => {
  }, []);

  const deleteRecord = async (id: string) => {
    const { errors } = await InvoiceTemplateApi.delete(id);
    if (errors?.length) {
      showAlert('danger', 'La Plantilla de Factura no puedo ser eliminado');
    } else {
      showAlert('success', 'La Plantilla de Factura fue eliminado correctamente');
    }
    modelRef.current?.refetch();
  }

  return (
    <PageContainer
      title="Lista de Plantillas de Facturas"
      backUrl="/user/invoices"
      primaryActions={[
        {
          onClick: () => {
            navigate('/user/invoicetemplates/add')
          },
          actionTitle: "Nuevo",
          color: "success"
        }
      ]}
    >
      <ModelIndex<InvoiceTemplateDataType>
        ref={modelRef}
        messages={{
          noResults: "No hay Plantillas de Facturas creadas aun"
        }}
        fetchData={(...args) => InvoiceTemplateApi.fetchAll(...args)}
        filterProps={[
          {
            key: "title",
            filterType: "contains"
          },
          {
            key: "numero",
            filterType: "eq",
            type: "number"
          }
        ]}
        secondaryProperties={[
          {
            key: "numero",
            highlighted: true
          },
          {
            key: "title",
            alignment: "Start"
          },
        ]}
        secondaryPropertiesSizing={
          [
            { sm: "2", xs: "3" },
            { sm: "6", xs: "6" }
          ]
        }
        listActions={[
          {
            href: "/user/invoicetemplates/copy/{:id}",
            actionTitle: "Copiar Plantilla de Factura",
            iconProps: { icon: faCopy }
          },
          {
            href: "/user/invoicetemplates/edit/{:id}",
            actionTitle: "Editar Plantilla de Factura",
            iconProps: { icon: faEdit }
          },
          {
            actionTitle: "Eliminar Plantilla de Factura",
            iconProps: { icon: faTrash },
            needConfirm: true,
            confirmProps: {
              title: "Eliminar Plantilla de Factura",
              confirmMessage: "¿Seguro que desea eliminar esta Plantilla de Factura?",
              confirmBtnText: "Eliminar"
            },
            onClick: (id: string) => { deleteRecord(id) }
          }
        ]}
      >
      </ModelIndex>

    </PageContainer >
  );
}

export default InvoiceTemplateIndex;
